/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { INSPECTOR_NODE_TYPE, isInspectorNodeDefault, TInspectorNode } from "../InspectorNodeTypes";
import { ISchemaRouteRefModel, isSchemaRouteRefModel } from "@adapptio/lib-blueprint";
import { mapModelToNodes } from "../index";
import { mapperDescriptor } from "../../modules/Core/ReferenceGuide/mappers/mapperDescriptor";
import { mapperExamples } from "../../modules/Core/ReferenceGuide/mappers/mapperExamples";
import { getParentComponentName } from "../utils";

export function routeRefMapper(model: ISchemaRouteRefModel): TInspectorNode {
	if (!isSchemaRouteRefModel(model)) {
		return;
	}

	const routeNameNode = mapModelToNodes(model.routeName);

	const routeNameControls = isInspectorNodeDefault(routeNameNode) ? routeNameNode.controls : [];

	return {
		type: INSPECTOR_NODE_TYPE.DEFAULT,
		key: `${model.nodeId}`,
		label: model.schema.opts.label,
		tooltip: model.schema.opts.description,
		required: model.schema.opts.constraints?.required || false,
		default: model.schema.opts["default"] || null,
		options: model.schema.opts["options"],
		referenceData: getParentComponentName(model),
		descriptor: mapperDescriptor(model.schema),
		examples: mapperExamples(model.schema),
		deps: [ model, ...routeNameNode.deps ],
		controls: [ ...routeNameControls ],
		children: [
			() => mapModelToNodes(model.params),
			() => mapModelToNodes(model.queryParams),
			() => mapModelToNodes(model.serializeNullParams)
		]
	};
}
